import React, { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';
const ExhibitionistConfigPopover = /*#__PURE__*/ lazy(()=>import(/* webpackChunkName: "owner" */ '..'));
const ExhibitionistConfigPopoverLazy = (props)=>{
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(WidgetConfigPopover, {
            isLoading: true,
            onClose: ()=>null
        })
    }, /*#__PURE__*/ React.createElement(ExhibitionistConfigPopover, props));
};
ExhibitionistConfigPopoverLazy.displayName = 'ExhibitionistConfigPopoverLazy';
export default ExhibitionistConfigPopoverLazy;

//# sourceMappingURL=ExhibitionistConfigPopoverLazy.js.map